export default function (dataArray, idArray, key = 'id') {
	return idArray.map((id) => dataArray.find((object) => object[key] === id));
}
